import script from "./TabelaValoresPlanos.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaValoresPlanos.vue?vue&type=script&setup=true&lang=js"

import "./TabelaValoresPlanos.vue?vue&type=style&index=0&id=de420880&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de420880"]])

export default __exports__